var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2034_390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2034_390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84712 5.38514C7.94712 6.01514 8.09558 6.61206 8.28943 6.98822C8.44174 7.28437 8.7402 7.66053 9.14943 8.07053C9.4302 8.35129 9.72789 8.6136 9.99866 8.83668C10.2694 8.6136 10.5679 8.35129 10.8479 8.07053C11.2571 7.66053 11.5556 7.28437 11.7079 6.98822C11.9017 6.61206 12.0494 6.01514 12.1502 5.38514H7.84712ZM7.33789 3.84668C6.68866 3.84668 6.1702 4.38283 6.24558 5.02822C6.34174 5.85591 6.53635 6.9436 6.92174 7.69283C7.43866 8.69668 8.62789 9.72591 9.36789 10.3028C9.74097 10.5951 10.2564 10.5951 10.6294 10.3028C11.3694 9.72591 12.5587 8.69668 13.0756 7.69283C13.461 6.94437 13.6556 5.85591 13.7525 5.02822C13.8271 4.38206 13.3087 3.84668 12.6594 3.84668H7.33789Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1508 14.6156C12.0508 13.9856 11.9024 13.3887 11.7085 13.0125C11.5562 12.7171 11.2577 12.3395 10.8485 11.9302C10.5775 11.6618 10.2941 11.4062 9.99929 11.1641C9.72852 11.3871 9.43006 11.6495 9.15006 11.9302C8.74083 12.3395 8.44236 12.7171 8.29006 13.0125C8.09621 13.3887 7.94852 13.9856 7.84775 14.6156H12.1508ZM12.6601 16.1541C13.3093 16.1541 13.8277 15.6179 13.7524 14.9733C13.6562 14.1448 13.4616 13.0564 13.0762 12.3079C12.5593 11.3041 11.3701 10.2748 10.6301 9.69791C10.4502 9.55642 10.2281 9.47949 9.99929 9.47949C9.77048 9.47949 9.54833 9.55642 9.36852 9.69791C8.62852 10.2748 7.43929 11.3041 6.92236 12.3079C6.53698 13.0564 6.34236 14.1448 6.24544 14.9733C6.17083 15.6179 6.68929 16.1541 7.33852 16.1541H12.6601Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69141 14.4234C7.69141 14.4234 9.22987 13.2695 9.9991 13.2695C10.7683 13.2695 12.3068 14.4234 12.3068 14.4234V14.808H7.69141V14.4234Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38281 4.23114C5.38281 4.02713 5.46386 3.83148 5.60812 3.68722C5.75237 3.54296 5.94803 3.46191 6.15204 3.46191H13.8444C14.0484 3.46191 14.244 3.54296 14.3883 3.68722C14.5325 3.83148 14.6136 4.02713 14.6136 4.23114C14.6136 4.43516 14.5325 4.63081 14.3883 4.77507C14.244 4.91933 14.0484 5.00038 13.8444 5.00038H6.15204C5.94803 5.00038 5.75237 4.91933 5.60812 4.77507C5.46386 4.63081 5.38281 4.43516 5.38281 4.23114ZM5.38281 15.7696C5.38281 15.5656 5.46386 15.3699 5.60812 15.2257C5.75237 15.0814 5.94803 15.0004 6.15204 15.0004H13.8444C14.0484 15.0004 14.244 15.0814 14.3883 15.2257C14.5325 15.3699 14.6136 15.5656 14.6136 15.7696C14.6136 15.9736 14.5325 16.1693 14.3883 16.3135C14.244 16.4578 14.0484 16.5388 13.8444 16.5388H6.15204C5.94803 16.5388 5.75237 16.4578 5.60812 16.3135C5.46386 16.1693 5.38281 15.9736 5.38281 15.7696Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2034_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#D87600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2034_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.d82034727ff39d62fd5c04b9622f20f4.svg";
export { ForwardRef as ReactComponent };